import handleSubmit from "./handleSubmit";
const $ = window.$;
$(function () {
    $(".nav-toggle")
        .unbind("click")
        .click(function (e) {
        $(e.currentTarget).toggleClass("active");
        if ($(e.currentTarget).hasClass("active")) {
            $(".global-menu-sp").addClass("active");
        }
        else {
            $(".global-menu-sp").removeClass("active");
        }
    });
    // 送信されたときのハンドラを登録
    const contactForm = document.getElementById("contact-form");
    if (contactForm) {
        contactForm.addEventListener("submit", (e) => {
            handleSubmit(e, contactForm);
        });
    }
});
